import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { etiquetaEstadoFiscal } from "../../servicios/facturacionElectronica";
import { PERMISOS, puedeAcceder } from "../../servicios/sesionSeguridad";
import { useStorePos } from "./useStorePos";

const valor = (item, ...claves) => {
  for (const clave of claves) {
    if (item?.[clave] !== undefined && item?.[clave] !== null && item?.[clave] !== "") return item[clave];
  }
  return "-";
};

const PosPendientesArca = () => {
  const { t } = useTranslation();
  const puedeReintentar = puedeAcceder(PERMISOS.VENTAS_CREAR);
  const pendientes = useStorePos((state) => state.PendientesArca);
  const cargando = useStorePos((state) => state.CargandoPendientesArca);
  const reintentando = useStorePos((state) => state.FacturasReintentando);

  useEffect(() => {
    if (puedeReintentar) useStorePos.getState().cargarPendientesArca();
  }, [puedeReintentar]);

  if (!puedeReintentar) {
    return <section className="pos-pendientes"><div className="pos-ticket-empty"><i className="pi pi-lock" /><strong>{t("pos.noPermissionCompleteSales")}</strong><span>{t("pos.pendingInvoicesPermissionHelp")}</span></div></section>;
  }

  return (
    <section className="pos-pendientes">
      <div className="pos-pendientes-header">
        <div>
          <h3 className="ing-subtitulo">{t("pos.pendingInvoicing")}</h3>
          <p className="pos-ayuda">{t("pos.pendingInvoicingHelp")}</p>
        </div>
        <button type="button" className="pos-btn-secundario" disabled={cargando} onClick={() => useStorePos.getState().cargarPendientesArca()}>
          <i className="pi pi-refresh" /> {cargando ? t("pos.updating") : t("common.refresh")}
        </button>
      </div>

      {!cargando && pendientes.length === 0 ? (
        <div className="pos-ticket-empty">
          <i className="pi pi-check-circle" />
          <strong>{t("pos.noPendingInvoices")}</strong>
          <span>{t("pos.inboxUpToDate")}</span>
        </div>
      ) : (
        <div className="pos-ticket-table-wrap">
          <table className="pos-ticket-table">
            <thead>
              <tr>
                <th>{t("pos.invoice")}</th><th>{t("common.status")}</th><th>{t("pos.deliveryNotes")}</th><th>{t("pos.attempts")}</th><th>{t("pos.lastError")}</th><th>{t("pos.lastAttempt")}</th><th>{t("pos.fiscalUser")}</th><th />
              </tr>
            </thead>
            <tbody>
              {pendientes.map((item, indice) => {
                const facturaId = Number(valor(item, "facturaId", "FacturaId", "Id")) || 0;
                const estado = String(valor(item, "estado", "Estado", "estadoFactura", "EstadoFactura"));
                const ocupado = reintentando.includes(facturaId);
                return (
                  <tr key={facturaId || indice}>
                    <td><strong>{valor(item, "facturaNumero", "FacturaNumero", "numero", "Numero", "FacturaId")}</strong></td>
                    <td><span className={`pos-estado-fiscal ${estado}`}>{etiquetaEstadoFiscal(estado)}</span></td>
                    <td>{valor(item, "remitos", "Remitos", "remitoNumero", "RemitoNumero")}</td>
                    <td>{valor(item, "cantidadIntentos", "CantidadIntentos", "intentos", "Intentos")}</td>
                    <td className="pos-error-cell">{valor(item, "ultimoError", "UltimoError", "error", "Error")}</td>
                    <td>{valor(item, "fechaUltimoIntento", "FechaUltimoIntento")}</td>
                    <td>{valor(item, "usuarioFiscal", "UsuarioFiscal", "usuarioId", "UsuarioId")}</td>
                    <td>
                      <button type="button" className="pos-btn-alerta" disabled={!facturaId || ocupado} onClick={() => useStorePos.getState().reintentarArca(facturaId)}>
                        <i className="pi pi-refresh" /> {ocupado ? t("pos.retrying") : t("pos.retry")}
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};

export default PosPendientesArca;
